import { createSlice } from "@reduxjs/toolkit";

export const WALLET_STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error",
};

const initialState = {
  error: null,
  lifetimeSpending: null,
  loading: false,
  // Loyalty wallet is held here rather than in component state so every
  // component that needs it reads the same value. `walletBalance` stays null
  // until it is actually known, so "not loaded yet" is distinguishable from
  // "no balance". `walletBrandId` records which brand the balance belongs to,
  // because this slice is persisted to sessionStorage.
  walletBalance: null,
  walletBrandId: null,
  walletStatus: WALLET_STATUS.IDLE,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLifetimeSpending: (state, action) => {
        state.lifetimeSpending = action.payload;
    },
    setWalletLoading: (state, action) => {
      const brandId = action.payload?.brandId ?? null;
      if (state.walletBrandId !== brandId) {
        // A balance belonging to another brand tells us nothing about this one.
        state.walletBalance = null;
      }
      state.walletBrandId = brandId;
      state.walletStatus = WALLET_STATUS.LOADING;
    },
    setWalletBalance: (state, action) => {
      state.walletBalance = Number(action.payload?.balance) || 0;
      state.walletBrandId = action.payload?.brandId ?? null;
      state.walletStatus = WALLET_STATUS.LOADED;
    },
    setWalletError: (state, action) => {
      state.walletBrandId = action.payload?.brandId ?? null;
      state.walletStatus = WALLET_STATUS.ERROR;
    },
  },
});

export const {
  setLifetimeSpending,
  setWalletLoading,
  setWalletBalance,
  setWalletError,
} = userSlice.actions;

export default userSlice.reducer;
